
import { defineComponent } from "@vue/runtime-core"
import Navigation from "@/components/Navigation.vue"
import Footer from "@/components/Footer.vue"
import "./assets/css/master.scss"
export default defineComponent({
  components: { Navigation, Footer },
})
